import React, { useRef } from 'react';
import _ from 'lodash';
import { INIT_PAGE_PROPERTY, ZOOM_STEP } from './store/constans';
import { Box, CircularProgress } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import APIDocuments from './apiDocuments';
//import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
    setCurrentPageSet,
    setZoomPage,
    setPageMovedPosition,
    setPageRotate,
    setPageReady,
    setActivePage,
} from './store/documentViewerReducer';
import { IMAGE_ORIENTATION, MANIPULATION, PAGE_LOAD_STATUS } from './store/enums';
import { decodeDocPageId } from './store/methods';
import { Magnifier } from './assets/icons';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';

const useStyles = makeStyles((theme) => ({
    root: {},
    loadingBox: {
        marginTop: '25%',
        marginLeft: 'calc(50% - 35px)',
    },
    viewer: {
        position: 'relative',
        overflow: 'auto',
        zIndex: 10,
        '&::-webkit-scrollbar-thumb:hover': {
            background: `transparent !important`,
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar': {
            width: '0px',
            height: '0px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'transparent',
        },
    },
    viewContainer: {
        position: 'relative',
        zIndex: 20,
    },
    imageItem: {
        position: 'absolute',
        transform: 'rotate(0deg)',
    },
    cursorPointer: {
        position: 'absolute',
        color: theme.palette.documentViewer.pageSelectedBackgroundColor,
    },
    backdrop: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: '0px',
        left: '0px',
        //background: 'rgba(20, 20, 20, 0.3)',
        display: 'block',
        zIndex: 30,
        '& .background-for-icon': {
            width: '30px',
            height: '30px',
            background: theme.palette.documentViewer.cursorIconBackgroundColor,
            borderRadius: '3px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
    },
}));

export function ViewerDocument(props) {
    const zoomStep = ZOOM_STEP;
    const classes = useStyles();
    const dispatch = useDispatch();
    const imageRef = React.useRef(null);
    const refToPageComponent = useRef(null);
    const { viewPortWidth = window.innerWidth - 390, viewPortHeight = 800 } = props;

    const zoom = useSelector((state) =>
        state.documentViewer.currentDocPageSet !== null ? state.documentViewer.currentDocPageSet.zoom : 0,
    );
    const rotation = useSelector((state) =>
        state.documentViewer.currentDocPageSet !== null ? state.documentViewer.currentDocPageSet.rotation : 0,
    );
    const currentPageSet = useSelector((state) => _.get(state, `documentViewer.currentDocPageSet`, INIT_PAGE_PROPERTY));
    const currentPageSetId = useSelector((state) => _.get(state, `documentViewer.currentDocPageSet.docPageId`, ''));
    const imageData = useSelector((state) => _.get(state, `documentViewer.currentDocPageSet.imageData`, null));
    const pageLoadStatus = useSelector((state) => _.get(state, `documentViewer.currentDocPageSet.status`, PAGE_LOAD_STATUS.NOT_LOADED));
    const pageCount = useSelector((state) => _.get(state, `documentViewer.currentToolbarSet.pageCount`, 0));

    const [loading, setLoading] = React.useState(true);
    const [currentPage, setCurrentPage] = React.useState(0);
    let docManipulationActive = false;
    let movementStart = { x: 0, y: 0, deg: 0 };
    let replaceCursorId = null;

    React.useEffect(() => {
        setLoading(true);
        if (currentPageSetId && currentPageSetId != '') {
            let { docId, page } = decodeDocPageId(currentPageSetId);
            setCurrentPage(page);
            if (pageLoadStatus === PAGE_LOAD_STATUS.NOT_LOADED) {
                let pageToolbarSettings = _.cloneDeep(currentPageSet);
                APIDocuments.getDocPage(docId, page).then(
                    (image) => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            if (reader.result != null && typeof reader.result == 'string') {
                                const i = new Image();
                                i.src = reader.result;
                                i.onload = () => {
                                    pageToolbarSettings.status = PAGE_LOAD_STATUS.LOADED;
                                    pageToolbarSettings.originalWidth = i.naturalWidth;
                                    pageToolbarSettings.originalHeight = i.naturalHeight;
                                    let tmpZoom = 3;
                                    if (pageToolbarSettings.originalWidth > pageToolbarSettings.originalHeight) {
                                        pageToolbarSettings.originalOrientation = IMAGE_ORIENTATION.LANDSCAPE;
                                        pageToolbarSettings.orientation = IMAGE_ORIENTATION.LANDSCAPE;
                                        while (pageToolbarSettings.originalWidth * tmpZoom > viewPortWidth * 0.95) {
                                            tmpZoom -= 0.0001;
                                        }
                                    } else {
                                        pageToolbarSettings.originalOrientation = IMAGE_ORIENTATION.PORTRAIT;
                                        pageToolbarSettings.orientation = IMAGE_ORIENTATION.PORTRAIT;
                                        while (pageToolbarSettings.originalHeight * tmpZoom > viewPortHeight * 0.95) {
                                            tmpZoom -= 0.0001;
                                        }
                                    }
                                    pageToolbarSettings.zoom = tmpZoom;
                                    pageToolbarSettings.imageData = reader.result;
                                    let imgWidth = pageToolbarSettings.originalWidth * pageToolbarSettings.zoom;
                                    let imgHeight = pageToolbarSettings.originalHeight * pageToolbarSettings.zoom;
                                    if (imgHeight < props.maxHeight) {
                                        pageToolbarSettings.top = (props.maxHeight - imgHeight) / 2;
                                    }
                                    if (imgWidth < props.maxWidth) {
                                        pageToolbarSettings.left = (props.maxWidth - imgWidth) / 2;
                                    }
                                    dispatch(setCurrentPageSet(pageToolbarSettings));
                                    setLoading(false);
                                };
                            } else {
                                pageToolbarSettings.imageData = '/image/assets/no-entry.png';
                                pageToolbarSettings.status = PAGE_LOAD_STATUS.ERROR_LOAD;
                                dispatch(setCurrentPageSet(pageToolbarSettings));
                                setLoading(false);
                            }
                        };
                        reader.readAsDataURL(image);
                    },
                    (error) => {
                        pageToolbarSettings.imageData = '/image/assets/no-entry.png';
                        pageToolbarSettings.status = PAGE_LOAD_STATUS.ERROR_SOURCE;
                        dispatch(setCurrentPageSet(pageToolbarSettings));
                        setLoading(false);
                    },
                );
            } else {
                setLoading(false);
            }
        } else {
            setCurrentPage(0);
            setLoading(false);
        }
    }, [currentPageSetId]);

    React.useEffect(() => {
        //Events
        const viewerPosition = document.getElementById('viewer').getBoundingClientRect();
        document.getElementById('backdrop').style.top = `${viewerPosition.top}px`;
        document.getElementById('backdrop').style.left = `${viewerPosition.left}px`;
        document.getElementById('backdrop').style.width = `${viewerPosition.width}px`;
        document.getElementById('backdrop').style.height = `${viewerPosition.height}px`;
        const setDefaultCursor = () => {
            document.getElementById('viewer').style.cursor = 'default';
            document.getElementById('backdrop').style.display = 'none';
            document.getElementById('zoomPageCursor').style.display = 'none';
            document.getElementById('changePageCursor').style.display = 'none';
        };
        setDefaultCursor();
        const stopCtrlScrollZoomOrChangePage = (ev) => {
            if (ev && ev.target) {
                const classesElement = ev.target.attributes.getNamedItem('class');
                if (classesElement && classesElement.value.indexOf('zoomable') > -1) {
                    const pageEl = document.getElementById('page-image');
                    if (pageEl) {
                        if (ev.ctrlKey || ev.metaKey) {
                            ev.preventDefault();
                            let newScale = 1.0;
                            const scale = pageEl.getAttribute('data-scale');
                            if (ev.deltaY > 0 && scale != null && scale != 'NaN' && scale != 'Infinity') {
                                newScale = parseFloat(scale) - zoomStep;
                            } else {
                                newScale = parseFloat(scale) + zoomStep;
                            }
                            pageEl.setAttribute('data-scale', newScale.toString());
                            dispatch(setZoomPage({ zoom: newScale }));
                        }
                        if (ev.altKey) {
                            ev.preventDefault();
                            let newPage = 0;
                            const currentPage = pageEl.getAttribute('data-current-page');
                            const pageCount = parseInt(pageEl.getAttribute('data-page-count') || 0);
                            if (currentPage != null && pageCount > 0) {
                                if (ev.deltaY > 0) {
                                    newPage = parseInt(currentPage) + 1;
                                } else {
                                    newPage = parseInt(currentPage) - 1;
                                }
                                if (newPage > 0 && newPage <= pageCount) {
                                    dispatch(setActivePage({ page: newPage }));
                                    setLoading(true);
                                }
                            }
                        }
                    }
                }
            }
        };
        document.getElementById('root').addEventListener('wheel', stopCtrlScrollZoomOrChangePage, { passive: false });
        const mouseDown = (ev) => {
            if (ev && ev.target && !docManipulationActive) {
                const classesElement = ev.target.attributes.getNamedItem('class');
                if (classesElement && classesElement.value.indexOf('draggable') > -1) {
                    const pageEl = document.getElementById('page-image');
                    if (pageEl) {
                        docManipulationActive = true;
                        const transform = pageEl.style.transform;
                        const rotate = transform.match(/rotate\((.*?)deg\)/);
                        let rotation = '0';
                        if (rotate && rotate.length > 0) {
                            rotation = transform.match(/rotate\((.*?)deg\)/)[1];
                        }
                        movementStart = {
                            x: ev.clientX,
                            y: ev.clientY,
                            baseX: parseInt(pageEl.style.left.replace('px', '')),
                            baseY: parseInt(pageEl.style.top.replace('px', '')),
                            baseRotate: parseInt(rotation),
                            action: ev.buttons == 2 ? MANIPULATION.ROTATE : ev.buttons == 1 ? MANIPULATION.MOVE : null,
                        };
                        if (ev.buttons === 1) document.getElementById('viewer').style.cursor = 'grab';
                        if (ev.buttons === 2) document.getElementById('viewer').style.cursor = 'alias';
                        ev.preventDefault();
                    }
                }
            }
        };
        document.getElementById('root').addEventListener('mousedown', mouseDown);
        const mouseMove = (ev) => {
            const classesElement = ev.target.attributes.getNamedItem('class');
            if (ev && ev.target) {
                if (docManipulationActive) {
                    if (classesElement && classesElement.value.indexOf('draggable') > -1) {
                        const deltaX = movementStart.x - ev.clientX;
                        const deltaY = movementStart.y - ev.clientY;
                        const pageEl = document.getElementById('page-image');
                        if (pageEl) {
                            if (movementStart.action == MANIPULATION.MOVE) {
                                pageEl.style.left = `${movementStart.baseX - deltaX}px`;
                                pageEl.style.top = `${movementStart.baseY - deltaY}px`;
                                if (document.getElementById('viewer').style.cursor == 'grab')
                                    document.getElementById('viewer').style.cursor = 'grabbing';
                            }
                            if (movementStart.action == MANIPULATION.ROTATE) {
                                pageEl.style.transform = `rotate(${movementStart.baseRotate + deltaX / 4}deg)`;
                            }
                        }
                    }
                    ev.preventDefault();
                } else {
                    if (classesElement && classesElement.value.indexOf('zoomable') > -1) {
                        movementStart.action = MANIPULATION.ACCESSABLE;
                    } else {
                        movementStart.action = MANIPULATION.NONE;
                    }
                }
            }
        };
        document.getElementById('root').addEventListener('mousemove', mouseMove);
        const mouseUp = (_ev) => {
            docManipulationActive = false;
            const pageEl = document.getElementById('page-image');
            if (pageEl) {
                if (movementStart.action == MANIPULATION.ROTATE) {
                    if (pageEl.style.transform) {
                        dispatch(setPageRotate({ rotation: pageEl.style.transform.match(/rotate\((.*?)deg\)/)[1] }));
                    }
                }
                if (movementStart.action == MANIPULATION.MOVE) {
                    dispatch(setPageMovedPosition({ top: pageEl.style.top, left: pageEl.style.left }));
                }
            }
            movementStart.action = MANIPULATION.ACCESSABLE;
            setDefaultCursor();
            replaceCursorId = null;
        };
        document.getElementById('root').addEventListener('mouseup', mouseUp);
        const disableContextMenu = (ev) => {
            if (ev && ev.target) {
                const classesElement = ev.target.attributes.getNamedItem('class');
                if (classesElement && classesElement.value.indexOf('draggable') > -1) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    return false;
                }
            }
        };
        document.getElementById('root').addEventListener('contextmenu', disableContextMenu);
        const keyPressOnImage = (ev) => {
            if (ev.keyCode && (ev.keyCode === 17 || ev.keyCode === 18)) {
                if (movementStart.action === MANIPULATION.ACCESSABLE) {
                    if (ev.keyCode === 17) {
                        movementStart.action = MANIPULATION.ZOOMABLE;
                        document.getElementById('zoomPageCursor').style.display = 'block';
                        document.getElementById('changePageCursor').style.display = 'none';
                        replaceCursorId = 'zoomPageCursor';
                    }
                    if (ev.keyCode === 18) {
                        movementStart.action = MANIPULATION.PAGINABLE;
                        document.getElementById('changePageCursor').style.display = 'block';
                        document.getElementById('zoomPageCursor').style.display = 'none';
                        replaceCursorId = 'changePageCursor';
                        ev.preventDefault();
                    }
                    if (replaceCursorId !== null) {
                        document.getElementById('backdrop').style.cursor = 'none';
                        document.getElementById('backdrop').style.display = 'block';
                    }
                }
                if (
                    movementStart.action !== MANIPULATION.ZOOMABLE &&
                    movementStart.action !== MANIPULATION.PAGINABLE &&
                    movementStart.action !== MANIPULATION.ACCESSABLE
                ) {
                    setDefaultCursor();
                }
            } else {
                setDefaultCursor();
            }
        };
        document.addEventListener('keydown', keyPressOnImage);
        const keyUpOnImage = (ev) => {
            if (
                ev.keyCode &&
                (ev.keyCode === 17 || ev.keyCode === 18) &&
                (movementStart.action === MANIPULATION.ZOOMABLE || movementStart.action === MANIPULATION.PAGINABLE)
            ) {
                movementStart.action = MANIPULATION.ACCESSABLE;
                setDefaultCursor();
                replaceCursorId = null;
            }
        };
        document.addEventListener('keyup', keyUpOnImage);
        return () => {
            document.getElementById('root').removeEventListener('wheel', stopCtrlScrollZoomOrChangePage, { passive: false });
            document.getElementById('root').removeEventListener('mousedown', mouseDown);
            document.getElementById('root').removeEventListener('mousemove', mouseMove);
            document.getElementById('root').removeEventListener('mouseup', mouseUp);
            document.getElementById('root').removeEventListener('contextmenu', disableContextMenu);
            document.removeEventListener('keydown', keyPressOnImage);
            document.removeEventListener('keyup', keyUpOnImage);
        };
    }, []);

    React.useEffect(() => {
        if (pageLoadStatus === PAGE_LOAD_STATUS.LOADED) {
            if (imageRef.current) {
                const pageElement = imageRef.current;
                if (pageElement) {
                    pageElement.setAttribute('data-scale', currentPageSet.zoom);
                    pageElement.setAttribute('data-current-page', currentPage);
                    pageElement.setAttribute('data-page_count', pageCount);
                    let imgWidth = currentPageSet.maW;
                    let imgHeight = currentPageSet.maH;
                    if (currentPageSet.originalWidth) {
                        imgWidth = currentPageSet.originalWidth * currentPageSet.zoom;
                    }
                    if (currentPageSet.originalHeight) {
                        imgHeight = currentPageSet.originalHeight * currentPageSet.zoom;
                    }
                    pageElement.style.width = '' + imgWidth + 'px';
                    pageElement.style.height = '' + imgHeight + 'px';
                    pageElement.style.transform = `rotate(${currentPageSet.rotation}deg)`;
                    pageElement.style.left = `${currentPageSet.left}px`;
                    pageElement.style.top = `${currentPageSet.top}px`;
                    dispatch(setPageReady({ ready: PAGE_LOAD_STATUS.READY }));
                }
            }
        }
    }, [pageLoadStatus, imageData, loading]);

    React.useEffect(() => {
        if (pageLoadStatus === PAGE_LOAD_STATUS.READY || pageLoadStatus === PAGE_LOAD_STATUS.LOADED) {
            if (imageRef.current) {
                const pageElement = imageRef.current;
                if (pageElement) {
                    pageElement.setAttribute('data-scale', zoom);
                    let imgWidth;
                    let imgHeight;
                    if (currentPageSet.originalWidth) {
                        imgWidth = currentPageSet.originalWidth * zoom;
                    }
                    if (currentPageSet.originalHeight) {
                        imgHeight = currentPageSet.originalHeight * zoom;
                    }
                    pageElement.style.width = '' + imgWidth + 'px';
                    pageElement.style.height = '' + imgHeight + 'px';
                    pageElement.style.top = '' + currentPageSet.top + 'px';
                    pageElement.style.left = '' + currentPageSet.left + 'px';
                }
            }
        }
    }, [zoom]);

    React.useEffect(() => {
        if (pageLoadStatus === PAGE_LOAD_STATUS.READY || pageLoadStatus === PAGE_LOAD_STATUS.LOADED) {
            if (imageRef.current) {
                const pageElement = imageRef.current;
                if (pageElement) {
                    pageElement.style.transform = `rotate(${rotation}deg)`;
                }
            }
        }
    }, [rotation]);

    return (
        <>
            <Box
                id={'viewer'}
                className={classes.viewer}
                width={props.maxWidth}
                height={props.maxHeight}
                maxWidth={props.maxWidth}
                maxHeight={props.maxHeight}
            >
                {currentPageSetId && currentPageSetId != '' && (
                    <Box
                        width={'100%'}
                        height={'100%'}
                        // maxWidth={props.maxWidth}
                        // maxHeight={props.maxHeight}
                        ref={refToPageComponent}
                        id="container-view"
                        className={`draggable zoomable ${classes.viewContainer}`}
                    >
                        {loading && (
                            <Box className={classes.loadingBox}>
                                <CircularProgress size={70}></CircularProgress>
                            </Box>
                        )}
                        {!loading && imageData != null && (
                            <Box
                                id="page-image"
                                data-current-page={currentPage}
                                data-page-count={pageCount}
                                data-scale={zoom}
                                component="img"
                                key={'image-page-' + props.docId}
                                className={`${classes.imageItem} draggable zoomable`}
                                src={imageData}
                                ref={imageRef}
                            />
                        )}
                    </Box>
                )}
            </Box>
            <Box
                id={'backdrop'}
                className={`${classes.backdrop} backdrop-layer zoomable`}
                width={props.maxWidth}
                height={props.maxHeight}
                maxWidth={props.maxWidth}
                maxHeight={props.maxHeight}
            >
                <Box className="background-for-icon">
                    <Magnifier className={`${classes.cursorPointer} additional-cursor zoomable`} id={'zoomPageCursor'} />
                    <AutoStoriesIcon className={`${classes.cursorPointer} additional-cursor zoomable`} id={'changePageCursor'} />
                </Box>
            </Box>
        </>
    );
}
